import {Stack} from "@mui/material";
import React from "react";
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import MovieIcon from "@mui/icons-material/Movie";
import ImageIcon from "@mui/icons-material/Image";
import {useSearchResultDetailsTranslation} from "../search-result-details/SearchResultDetailsContext";
import Box from "@mui/material/Box";
import {b64NoImage} from "../no-thumbnail";
import {ImageLoader} from "../ImageLoader";

// Module-level style constants — created once, never recreated on re-render.
// backgroundImage is in inline style (not CSS file) so webpack's css-loader
// does not attempt to resolve the public-asset URL as a module.
const imageThumbnailStyle = {
    width: "100px",
    maxWidth: "100px",
    background: "#eeeeee",
    objectFit: "contain",
    backgroundImage: `url("${b64NoImage}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
};

const objectTypeIconSx = {
    position: "relative",
    bottom: 0,
    right: "24px",
    zIndex: 99,
    background: "#fff",
    color: "#666",
    opacity: 0.7,
    borderRadius: "3px 0 0 0",
};

const iconThumbNailSx = {
    fontSize: 60,
    color: "#bbb",
    background: "#eee",
    width: "100px !important",
    minWidth: "100px",
    minHeight: "100px",
};

const containerBoxSx = {
    border: '1px solid #ddd',
    width: '100%',
    height: '100%',
    backgroundColor: '#ddd',
    textAlign: 'center',
    verticalAlign: 'middle',
};

/**
 * Displays a thumbnail, based on the model.documentType in square,
 * with an overlay icon that symbolizes the type of document.
 * @param model object  The model
 * @returns {JSX.Element}
 */
export const SquareThumbWithDocTypeOverlay = ({model, ...props}) => {
    const t = useSearchResultDetailsTranslation();

    const documentType = model.documentType;
    const mimeType = model.mimeType;

    const getThumbnail = () => {
        if (documentType !== "Audio" && documentType !== "Misc") {
            return (
                <Box sx={containerBoxSx}>
                    <ImageLoader alt={model.title}
                                 src={model.imageUrl}
                                 style={imageThumbnailStyle}
                                 loading="eager"/>
                </Box>
            );
        } else if (documentType === "Audio") {
            return <VolumeUpOutlinedIcon sx={iconThumbNailSx}/>;
        } else if (documentType === "Misc" && mimeType !== "pdf") {
            return <DescriptionIcon sx={iconThumbNailSx}/>;
        }
    };

    const getObjectTypeIcon = () => {
        if (documentType === "Audio") {
            return <VolumeUpOutlinedIcon sx={objectTypeIconSx}/>;
        } else if (documentType === "Misc" && mimeType !== "pdf") {
            return <DescriptionIcon sx={objectTypeIconSx} aria-label={t("txtDocument", "Dokument")}/>;
        } else if (documentType === "Video") {
            return <MovieIcon sx={objectTypeIconSx} aria-label={t("txtVideo", "Video")}/>;
        } else if (documentType === "StillImage") {
            return <ImageIcon sx={objectTypeIconSx} aria-label={t("txtImage", "Bilde")}/>;
        }
    };

    return (
        <Stack direction="row" sx={{width: "100px"}} key={`${props.key ? props.key : 'thumb'}-${model.uniqueId}`}>
            {getThumbnail()}
            {getObjectTypeIcon()}
        </Stack>
    );
};
